/*============================================================================
  Global - header
==============================================================================*/

var header = {
  init: function(){

    /* Mobile menu */
    $('.navicon_button').on('click', function() {
      $('.toggle_menu').toggle();
    });

    $('.mobile_menu span').on('click', function(e) {
      var $toggle = $(this);
      if($toggle.next('ul').is(':visible')) {
        $toggle.next('ul').hide();
        $toggle.html('+');
        $toggle.attr('aria-expanded', false);
      } else {
        $toggle.next('ul').show();
        $toggle.html('-');
        $toggle.attr('aria-expanded', true);
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    $('.mobile_menu .text_link').on('click', function(e) {
      $(this).next('span').click();
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    /* Promotional Banner */
    if ($('.js-promo_banner').length) {
      var promo_banner = $.cookie('promo_banner');

      if (promo_banner != 'dismiss') {

        $('body').addClass('promo_banner-show');
        $('.promo_banner').on('click', '.promo_banner-close', function(){
          $('body').removeClass('promo_banner-show');
          $.cookie('promo_banner', 'dismiss', { expires: 30 });
        });
      }
    }

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/i.test(navigator.userAgent) && $(window).width() >= 768) {
      $(document).on('click', 'li.sub-menu > a', function(e) {
        e.preventDefault();
        return false;
      });
    }

    $('body').on('mouseover', '.sub-menu', function() {
      $(this).attr('aria-expanded', true);
    });
    $('body').on('mouseout', '.sub-menu', function() {
     $(this).attr('aria-expanded', false);
    });
  },
  unload: function($target){

  }
}

/*============================================================================
  Home page - banner
==============================================================================*/

var banner = {
  init: function(){
    $('.slider').flexslider({
      touch: false,
      directionNav: false,
      controlNav: false,
      animation: "fade"
    });
  },
  unload: function($target){
    var slider = $target.find('.slider');
    destroySlider(slider);
  }
}

var cart = {
  init: function(){
    $("#address_country").val($("#address_country").data("default")).change();
  },
  unload: function(){
  }
}

/*============================================================================
  Home page - slideshow
==============================================================================*/

var slideshow = {
  init: function(){
    $('.homepage_slider').each(function (index, value){
      var homepageSlider = $(this);
      var slideshowAnimation = homepageSlider.data('slideshow-animation');
      var slideshowSpeed = homepageSlider.data('slideshow-speed');
      var slideshowTextAnimation = homepageSlider.data('slideshow-text-animation')

      homepageSlider.flexslider({
        touch: true,
        controlNav: true,
        animation: slideshowAnimation,
        slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
        start: function(slider){
          if (slideshowTextAnimation) {
            $(slider).find(".flex-active-slide").find('.container').addClass("animated " + slideshowTextAnimation );
          }

        },
        before: function(slider){
          $(slider).find(".flex-active-slide").find('.container').each(function(){
            $(this).removeClass("animated " + slideshowTextAnimation);
          });
        },
        after: function(slider){
          $(slider).find(".flex-active-slide").find('.container').addClass("animated " + slideshowTextAnimation);
        }
      });
    });
  },
  unload: function($target){
    var slider = $target.find('.homepage_slider');
    destroySlider(slider);
  }
}

/*============================================================================
  Home page - testimonial
==============================================================================*/

var testimonial = {
  init: function(){
    $('.testimonial_slider').each(function (index, value){
      var testimonialSlider = $(this);
      var slideshowAnimation = testimonialSlider.data('slideshow-animation');
      var slideshowSpeed = testimonialSlider.data('slideshow-speed');
      var slideshowTextAnimation = testimonialSlider.data('slideshow-text-animation')

      testimonialSlider.flexslider({
        touch: true,
        controlNav: true,
        animation: slideshowAnimation,
        slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
        start: function(slider){
          if (slideshowTextAnimation) {
            $(slider).find(".flex-active-slide").find('.container').addClass("animated " + slideshowTextAnimation );
          }

        },
        before: function(slider){
          $(slider).find(".flex-active-slide").find('.container').each(function(){
            $(this).removeClass("animated " + slideshowTextAnimation);
          });
        },
        after: function(slider){
          $(slider).find(".flex-active-slide").find('.container').addClass("animated " + slideshowTextAnimation);
        }
      });
    });
  },
  unload: function($target){
    var slider = $target.find('.testimonial_slider');
    destroySlider(slider);
  }
}

/*============================================================================
  Home page - video
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function(){
  return !!document.createElement('video').canPlayType;
}

var homepageVideo = {
  unload: function($target){
    $target.find('[data-play-video]').off('click');
  },
  getVideoDetails: function(settings){
    var videoDetails = {
        id: settings.header.attr('data-video-src'),
        aspectRatio: settings.header.attr('data-aspect-ratio').split(":"),
        provider: settings.header.attr('data-provider').toLowerCase(),
        videoMP4: settings.header.attr('data-video-mp4'),
        videoOGV: settings.header.attr('data-video-ogv')
    }
    return videoDetails;
  },
  createFrame: function(settings, videoDetails){

    if(videoDetails.provider === 'youtube') {
      if (settings.autoloop){
        var autoloop = '1&iv_load_policy=3&playlist='+videoDetails.id;
      } else {
        var autoloop = 0;
      }

      var html = '<iframe src="//www.youtube.com/embed/'+videoDetails.id+'?&autoplay=1&loop='+autoloop+'&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    else if(videoDetails.provider === 'vimeo') {
      if (settings.autoloop){
        var autoloop = 1;
      } else {
        var autoloop = 0;
      }
      var html = '<iframe src="//player.vimeo.com/video/'+videoDetails.id+'?loop='+autoloop+'&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    else if(videoDetails.provider === 'html5') {
      if (settings.autoloop){
        var autoloop = "loop=\"loop\"";
      }

      var html = "<video autoplay=\"true\" " + autoloop + " id=\"video\"><source src=\"" + videoDetails.videoMP4 + "\" type=\"video/mp4\"><source src=\"" + videoDetails.videoOGV + "\" type=\"video/ogg\"></video>";
    }
    return html;
  },
  appendFrame: function(settings, videoDetails){
    var addVideo = function(){
      //only add video if there are no videos already in the section
      if (settings.container.find('.mediaWrapper').length < 1 && settings.container.find('#video').length < 1){
        settings.container.append(homepageVideo.createFrame(settings, videoDetails));
      }

      if (videoDetails.provider != 'html5'){
        settings.container.find('iframe').mediaWrapper({
          intrinsic: false,
          baseWidth : videoDetails.aspectRatio[0],
          baseHeight: videoDetails.aspectRatio[1]
        });
      }
    }

    if(!homepageVideo.isMobile()) {
      addVideo();
      var mediaWrapper = settings.container.find('.mediaWrapper');
      settings.container.height(mediaWrapper.outerHeight());
      settings.posterImage.addClass('fadeOut animated');

      if (settings.bannerVideoText){
        settings.videoText.addClass('text-on-video');
      } else {
        settings.videoText.hide();
      }

      settings.header.next().fadeIn('slow');
      if (videoDetails.provider != 'html5'){
        mediaWrapper.find('iframe').show();
      } else {
        settings.header.next().show();
        settings.container.find('.homepage-video__placeholder').hide();
        settings.container.find('.homepage-video__image').hide();
      }

      settings.videoTrigger.removeAttr('data-play-video');

    }
  },
  isMobile: function(){
    return false; //initiate as false
    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) return true;
  }
}

var video = {
  init: function(){

    //Check for videos that are set to autoplay
    $('.homepage-video').each(function (index, value) {
      if ($('.homepage-video').length && supports_video()) {

        var $videoElement = $(this);
        var settings = {
          container: $videoElement,
          header: $videoElement.find('.homepage-video--media'),
          posterImage: $videoElement.find('.homepage-video img[data-play-video]'),
          videoText: $videoElement.find('.homepage-video--media .caption'),
          videoTrigger: $videoElement.find("[data-play-video]"),
          autoPlayVideo: $videoElement.data('autoplay'),
          bannerVideoText: $videoElement.data('video-text'),
          autoloop: $videoElement.data('autoloop')
        }
        var videoDetails = homepageVideo.getVideoDetails(settings);

        if (settings.autoPlayVideo && !homepageVideo.isMobile()){
          homepageVideo.appendFrame(settings, videoDetails);
        }

      }
    });

    //Attach event listener for videos
    $(document).on('click', '[data-play-video]', function(e) {
      var $videoElement = $(this).parents('.homepage-video');
      var settings = {
        container: $videoElement,
        header: $videoElement.find('.homepage-video--media'),
        posterImage: $videoElement.find('.homepage-video img[data-play-video]'),
        videoText: $videoElement.find('.homepage-video--media .caption'),
        videoTrigger: $videoElement.find("[data-play-video]"),
        autoPlayVideo: $videoElement.data('autoplay'),
        bannerVideoText: $videoElement.data('video-text'),
        autoloop: $videoElement.data('autoloop')
      }
      var videoDetails = homepageVideo.getVideoDetails(settings);

      homepageVideo.appendFrame(settings, videoDetails);
    });
  }
}

/*============================================================================
  Home page - social media
==============================================================================*/

var social = {
  twitter: function(){
    if (window.twttr) {
      window.twttr.ready(function (twttr) {
        twttr.widgets.load();
      });
    }
  },
  unload: function(){

  }
}

/*============================================================================
  Product
==============================================================================*/

var product = {
  init: function(){
    var thumbnailPosition = $('.product_slider').parents('.product_section').data('thumbnail');
    var slideshowAnimation = $('.product_slider').parents('.product_section').data('slideshow-animation');
    var slideshowSpeed = $('.product_slider').parents('.product_section').data('slideshow-speed');
    var $notify_form = $('.notify_form .contact-form');

    if (slideshowAnimation == 'zoom'){
      CloudZoom.quickStart();
    }

    $('.product_slider').flexslider({
      startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
      touch: true,
      pauseOnHover: true,
      controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
      directionNav: thumbnailPosition == "no-thumbnails" ? true : false,
      animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
      slideshow: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? false : true,
      slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
      start: function(slider){
        slider.resize();
      }
    });

    if (slideshowAnimation == 'slide'){
      if($('.product_slider img').data("index") == 0) { $('.product_slider .flex-direction-nav').hide() }
    } else {
      if($('.product_slider img').length == 1) { $('.product_slider .flex-direction-nav').hide() }
    }

    $('form.product_form.product_form_options.init').each(function() {
      new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(this).data("enable-state") });
    });

    $notify_form.each(function() {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $nf.fadeOut("slow", function(){
                $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
              });
            },
            error: function(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    
  },
  unload: function($target){
    var slider = $target.find('.product_slider');
    destroySlider(slider);
  }
}

/*============================================================================
  Collection
==============================================================================*/

var collection = {
  init: function(){

    

    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/i.test(navigator.userAgent) ) {
      $(".quick_shop").remove();
    } else {
      $('.thumbnail').hover(function(){
        $(this).find('.quick_shop').show();

      }, function(){
        $(this).find('.quick_shop').hide();
      })

      

      var modal_width = '840px';
      if($(window).width() >= 1200 || $('html').hasClass('ie')) {
        modal_width = '1080px'
      }
      $(".quick_shop").fancybox({
        width: modal_width,
        height: 'auto',
        autoSize: false,
        padding: [20, 20, 20, 20],
        afterShow: function(e) {
         var selector = $('.fancybox-opened').find('.selector-wrapper select');
         selector.trigger('change');
        }
      });
    }

    $('#sort-by').val($('#sort-by').data('default-sort'));

    $('body')
      .on('change', '#tag_filter, #sort-by', function() {
        var sortValue = $('#sort-by').val();
        var filterValue = $('#tag_filter').val();

        Shopify.queryParams.sort_by = sortValue;
        sortUrl = $.param(Shopify.queryParams);

        if (sortValue && filterValue){
          window.location = filterValue + '?' + sortUrl;
        } else if (sortValue && !filterValue) {
          window.location = '?' + sortUrl;
        } else if (!sortValue && filterValue){
          window.location = filterValue;
        }
    });
  },
  unload: function($target){
    $target.find('.thumbnail').off('mouseenter mouseleave');
    $('body').off('change', '#tag_filter, #sort-by');
    $target.find('.quick_shop').unbind('click.fb');
  }
}

/*============================================================================
  Cart
==============================================================================*/

var ajaxCart = {
  init: function(){
      $('body').on('submit', '.product_form', function(e) {
        e.preventDefault();
        var $addToCartForm = $(this);
        var $addToCartBtn = $addToCartForm.find('.add_to_cart');

        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          type: 'post',
          data: $addToCartForm.serialize(),
          beforeSend: function() {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
            $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
          },
          success: function(itemData) {
            $addToCartBtn.find('span').text("Added").removeClass('zoomOut').addClass('fadeIn');
            $addToCartForm.find('.continue_shopping').show().addClass('animated fadeInUp');

            window.setTimeout(function(){
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
            }, 1000);

            $.getJSON("/cart.js", function(cart) {
              refreshCart(cart);
            });
          },
          error: function(XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            $('.warning').remove();

            var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
            $addToCartForm.after(warning);
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
          }
        });

        return false;
      });
  }
}

/*============================================================================
  Utilities/utils
==============================================================================*/

var toggleSidebarBlocks = function($toggle){
  if($toggle.next('ul').is(':visible')) {
    $toggle.next('ul').hide();
    $toggle.children('span').html('+');
    $toggle.attr('aria-expanded', false);
  } else {
    $toggle.next('ul').show();
    $toggle.children('span').html('-');
    $toggle.attr('aria-expanded', true);
  }
}

var toggleSidebarMenus = function($toggle){
  var $content = $toggle.next('ul');
  $content.slideToggle();
  $toggle.toggleClass('active');
  $toggle.attr('aria-expanded', $toggle.attr('aria-expanded') == 'true' ? 'false' : 'true');
}

var showSecondaryImage = function(){
  $('body').on("mouseenter", ".thumbnail", function() {
    $(this).addClass('toggle-images');
  });

  $('body').on("mouseleave", ".thumbnail", function() {
    $(this).removeClass('toggle-images');
  });
}

var sliderBlock = {
  select: function(blockId, $parentSection){
    var $blocks = $parentSection.find('li[data-block-id]:not(".clone")');
    var blockIdsArray = $blocks.map(function() {
      return String($(this).data('block-id'));
    });
    var slider = $parentSection.find('.flexslider').data('flexslider');

    slider.pause();

    for(var i = 0; i < blockIdsArray.length; i++){
      if(blockIdsArray[i] === blockId){
        var currentSlide = i;
        if (currentSlide !== slider.currentSlide){
          slider.flexAnimate(parseInt(currentSlide));
        }
      }
    }
  },
  deselect: function($parentSection){
    var slider = $parentSection.find('.flexslider').data('flexslider');
    if(slider) {
      slider.play();
    }
  }
}

//Document ready
$(function() {

  //Lazysizes expand area for loading (makes images load faster)
  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.expand = 1000;

  //Load sections
  header.init();
  banner.init();
  slideshow.init();
  testimonial.init();
  product.init();
  collection.init();
  cart.init();
  video.init();

  $('.banner-flexslider').flexslider({touch: false, controlNav: false, directionNav: false, animation: "slide" });
  $('.slider').flexslider({touch: false, controlNav: false, animation: "slide" });
  $('.slider-no-nav').flexslider({touch: false, controlNav: false, directionNav: false, animation: "slide" });
  $('.slider-no-nav-quick').flexslider({touch: false, controlNav: false, directionNav: false, animation: "slide", slideshowSpeed: 4000 });

  //Sidebar toggle
  $(document).on('click', '.menu-toggle', function(e) {
    toggleSidebarMenus($(this));
  });
  var sidebarTouched = false;
  $(document).on('touchstart', '.toggle', function(e) {
    if ($(window).width() <= 767 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
      var $toggle = $(this);
      toggleSidebarBlocks($toggle);
      sidebarTouched = true;
    }
    e.preventDefault();
    return false;
  })
  $(document).on('click', '.toggle', function(e) {
    if ($(window).width() <= 767 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
      var $toggle = $(this);
      if (!sidebarTouched) {
        toggleSidebarBlocks($toggle);
      }
    }
    e.preventDefault();
    return false;
  });

  $('.toggle_list').each(function() {
    if($(this).is(':visible')) {
      $(this).prev('.toggle').attr('aria-expanded', true);
    }
  });


  $(".dropdown").each(function() {
    if($(this).offset().left - $(window).scrollLeft() > $(window).width()/2) {
      $(this).addClass("dropdown_left");
    }
  });

  $('.lightbox').fancybox();

  $(".fancybox").fancybox({
    padding: 0,
    wrapCSS: 'gallery'
  });

  $('.close').on('click', function() {
    $.fancybox.close();
  });

  if($('.flexslider img').length == 1) {
    $('.flexslider .flex-direction-nav').hide();
  }

  

  $('#tag_filter').change(function() {
    window.location = $('#tag_filter option:selected').val();
  });

  $('.update_subtotal').click(function() {
    $("#cart_form").submit(); return false;
  });

  $("#cart_form input[type='number']").change(function() {
    $("#cart_form").submit();
  });

  if ($('.tos_agree').length) {
    $('body').on('click', '#checkout', function() {
      if ($('.tos_agree').is(':checked')) {
        $(this).submit();
      } else {
        alert("You must agree with the terms and conditions to checkout.");
        return false;
      }
    });
  }

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  //Load Accordions
  var allPanels = $('.accordion > dd').hide();

  $('.accordion > dt > a').click(function() {
    if(!$(this).parent().next().is(':visible')) {
      allPanels.slideUp();
      $('.accordion small.right').html('&#9668;');
      $(this).find('small.right').html('&#9660;');
      $(this).parent().next().slideDown();
    }

    return false;
  });

  $('.accordion dd:first-of-type').show();

  //Load Tabs
  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });

  if ($('.shopify-section.page-details-section').length){
    // Don't apply mediaWrapper
  } else if ($('body').hasClass('index')) {
    $('.featured-products-section iframe[src*=youtube], .featured-products-section iframe[src*=vimeo]').mediaWrapper({
      intrinsic: true
    });
  } else {
    $('iframe[src*=youtube], iframe[src*=vimeo]').mediaWrapper({
      intrinsic: true
    });
  }

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on('submit', function (e) {
      if($('input[name="challenge"]', $cf).val() !== "true") {
        $.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {
            $cf.fadeOut("slow", function(){
              $cf.prev('.message').html("Thanks for Signing up! Here is your coupon code: SUN10");
            });
          },
          error: function(data) {
            $('input[name="challenge"]', $cf).val('true');
            $cf.submit();
          }
        });
        e.preventDefault();
      }
    });
  });

  

  /*============================================================================
    Home page - social media
  ==============================================================================*/

  //Initialize twitter feed
  window.twttr = (function (d,s,id) {
  var t, js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return; js=d.createElement(s); js.id=id;
  js.src="https://platform.twitter.com/widgets.js";
  fjs.parentNode.insertBefore(js, fjs);
  return window.twttr || (t = { _e: [], ready: function(f){ t._e.push(f) } });
  }(document, "script", "twitter-wjs"));

  $('.twitter-feed-wrap').each(function (index, value) {
    social.twitter();
  });

  $('.instagram-feed-wrap').each(function (index, value) {
    var $target = $(this).find(".js-instafeed");
    instagram.loadContent({
      el: $target,
      clientID: $target.data('client-id'),
      limit: $target.data('count')
    });
  });

  
});

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/
  function ajaxSubmitCart() {
    $cart = $("#cart");
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function refreshCart(cart) {
    $cartBtn = $(".cart_button");
    if ($cartBtn) {
      var $cartCount = $cartBtn.find('.cart_count');
      if(cart.item_count == 0) {
        $cartCount.remove();
        $cartBtn.removeClass('active');
      } else if ($cartCount.length) {
        $cartCount.html('<span class="cart_count"> (' + cart.item_count + ')</span>');
        $cartBtn.addClass('active');
      } else {
        $cartBtn.append('<span class="cart_count"> (' + cart.item_count + ')</span>');
        $cartBtn.addClass('active');
      }
    }
  }

  selectCallback = function (variant, selector) {
    const productId = selector.product.id;
    const productEl = document.querySelector('.product-' + productId);
    const notifyFormEl = document.querySelector('.notify-form-' + productId);
    const productFormEl = productEl?.querySelector('form.product_form');

    // Early return if product element not found
    if (!productEl) {
      console.warn('selectCallback: Product element not found for ID:', productId);
      return;
    }

    // Parse variant inventory from data attribute
    let variantInventory = null;
    if (productFormEl?.dataset.variantInventory) {
      try {
        variantInventory = JSON.parse(productFormEl.dataset.variantInventory);
      } catch (e) {
        console.error('Failed to parse variant inventory:', e);
      }
    }

    const moneyFormat = productFormEl?.dataset.moneyFormat || '';
    const shopCurrency = productFormEl?.dataset.shopCurrency;

    if (variant && variant.featured_image && productEl && productEl.offsetParent !== null) {
      const sliders = productEl.querySelectorAll('.product_slider');
      sliders.forEach(slider => {
        if (slider.offsetParent !== null) {
          // flexslider requires jQuery - search for image index within productEl scope
          const imageEl = productEl.querySelector(`[data-image-id="${variant.featured_image.id}"]`);
          const index = imageEl?.dataset.index;
          if (index) {
            $(slider).flexslider(parseInt(index));
          }
        }
      });
    }

    // Quick Shop
    if (variant && variant.featured_image && productEl && productEl.offsetParent !== null && !productFormEl?.classList.contains("init")) {
      const popimgEl = productEl.querySelector('.modal_image');
      const popOriginalImage = productEl.querySelector('.modal_image img');
      const newImage = variant.featured_image;

      if (popimgEl && popOriginalImage) {
        Shopify.Image.switchImage(newImage, popOriginalImage, function (new_image_src, pop_original_image, element) {
          popimgEl.innerHTML = '<img src="' + variant.featured_image.src + '"/>';
        });
      }
    }

    if (variant) {
      if (variantInventory) {
        variantInventory.forEach((v) => {
          if (v.id === variant.id) {
            variant.inventory_quantity = v.inventory_quantity;
            variant.inventory_management = v.inventory_management;
            variant.inventory_policy = v.inventory_policy;
          }
        });
      }

      const skuSpan = productEl?.querySelector('.sku span');
      if (skuSpan) skuSpan.textContent = variant.sku;

      const notifyFormMsg = productEl?.querySelector('.notify_form_message');
      if (notifyFormMsg) {
        notifyFormMsg.value = notifyFormMsg.dataset.body + " - " + variant.title;
      }

      
    }

    if (variant && variant.available == true) {
      const wasPriceEl = productEl?.querySelector('.was_price');
      if (wasPriceEl) {
        if (variant.price < variant.compare_at_price) {
          wasPriceEl.innerHTML = '<span class="money">' + Shopify.formatMoney(variant.compare_at_price, moneyFormat) + '</span>';
        } else {
          wasPriceEl.innerHTML = "";
        }
      }

      if (variant.inventory_management && variant.inventory_quantity > 0) {
        
        
      } else {
        const itemsLeftEl = productEl?.querySelector('.items_left');
        if (itemsLeftEl) itemsLeftEl.textContent = '';

        const quantityEl = productEl?.querySelector('.quantity');
        if (quantityEl) quantityEl.removeAttribute('max');
      }

      const soldOutEl = productEl?.querySelector('.sold_out');
      if (soldOutEl) soldOutEl.textContent = '';

      const currentPriceEl = productEl?.querySelector('.current_price');
      if (currentPriceEl) {
        if (variant.price > 0) {
          currentPriceEl.innerHTML = '<span class="money">' + Shopify.formatMoney(variant.price, moneyFormat) + '</span>';
        } else {
          currentPriceEl.innerHTML = "$0";
        }
      }

      const addToCartBtn = productEl?.querySelector('.add_to_cart');
      if (addToCartBtn) {
        addToCartBtn.classList.remove('disabled');
        addToCartBtn.removeAttribute('disabled');
        const btnSpan = addToCartBtn.querySelector('span');
        if (btnSpan) btnSpan.textContent = addToCartBtn.dataset.label;
      }

      if (notifyFormEl) notifyFormEl.style.display = 'none';
    } else {
      const message = variant ? "Sold Out" : "Unavailable";

      const wasPriceEl = productEl?.querySelector('.was_price');
      if (wasPriceEl) wasPriceEl.innerHTML = '';

      const currentPriceEl = productEl?.querySelector('.current_price');
      if (currentPriceEl) currentPriceEl.innerHTML = '';

      const itemsLeftEl = productEl?.querySelector('.items_left');
      if (itemsLeftEl) itemsLeftEl.textContent = '';

      const quantityEl = productEl?.querySelector('.quantity');
      if (quantityEl) quantityEl.removeAttribute('max');

      const soldOutEl = productEl?.querySelector('.sold_out');
      if (soldOutEl) soldOutEl.textContent = message;

      const addToCartBtn = productEl?.querySelector('.add_to_cart');
      if (addToCartBtn) {
        addToCartBtn.classList.add('disabled');
        addToCartBtn.setAttribute('disabled', 'disabled');
        const btnSpan = addToCartBtn.querySelector('span');
        if (btnSpan) btnSpan.textContent = message;
      }

      // fadeIn requires jQuery for animation
      if (notifyFormEl) $(notifyFormEl).fadeIn();
    }

    

    productFormEl?.classList.remove("init");
  };

var destroySlider = function(slider) {
  if (slider && slider.data('flexslider')){
    var slider = slider.data('flexslider');

    var classNamespace = '.' + slider.vars.namespace; // Namespaced class selector
    if (slider.vars.controlNav) slider.controlNav.closest(classNamespace + 'control-nav').remove(); // Remove control elements if present
    if (slider.vars.directionNav) slider.directionNav.closest(classNamespace + 'direction-nav').remove(); // Remove direction-nav elements if present
    if (slider.vars.pausePlay) slider.pausePlay.closest(classNamespace + 'pauseplay').remove(); // Remove pauseplay elements if present
    slider.find('.clone').remove(); // Remove any flexslider clones
    slider.unbind(slider.vars.eventNamespace); // Remove events on slider
    if ( slider.vars.animation != "fade" ) slider.container.unwrap(); // Remove the .flex-viewport div
    slider.container.removeAttr('style') // Remove generated CSS (could collide with 3rd parties)
    slider.container.unbind(slider.vars.eventNamespace); // Remove events on slider
    slider.slides.removeAttr('style'); // Remove generated CSS (could collide with 3rd parties)
    slider.slides.filter(classNamespace + 'active-slide').removeClass(slider.vars.namespace + 'active-slide'); // Remove slide active class
    slider.slides.unbind(slider.vars.eventNamespace); // Remove events on slides
    $(document).unbind(slider.vars.eventNamespace + "-" + slider.id); // Remove events from document for this instance only
    $(window).unbind(slider.vars.eventNamespace + "-" + slider.id); // Remove events from window for this instance only
    slider.stop(); // Stop the interval
    slider.removeData('flexslider'); // Remove data
  }
}

var instagram = {
  loadContent: function(s){
    if(s.clientID) {
      var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+s.clientID+'&count=25';

      $.ajax({
        type: 'GET',
        url: url,
        dataType: 'jsonp',
        success: function(data) {

          if(data.meta.code === 200 && data.data.length) {
            var data = data.data;
            var count = 0;
            s.el.empty();

            for(var i = 0; i < data.length; i++) {
              var thisMedia = data[i], item;

              var url = thisMedia.images.low_resolution.url;

              if(!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                item = '<div class="il-photo__img instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link">'+item+'</a>';
              }

              if(thisMedia.videos) {
                item = '<div class="instagram__video instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link instagram__video-link">'+item+'</a>';
              }

              if(item) {
                item = '<div class="instas instagram__item">'+item+'</div>';
              }
              if(item !== '') {
                s.el.append(item);
                count++;
              }
              if(count == s.limit) {
                break;
              }
            }
          }
        },
        error: function() {
        }
      });
    }
  }
}

$(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.select(blockId, $parentSection);
    }

});

$(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.deselect($parentSection)
    }

});

$(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('instagram-feed-section')){
      $('.instagram-feed-wrap').each(function (index, value) {
        var $target = $(this).find(".js-instafeed");
        instagram.loadContent({
          el: $target,
          clientID: $target.data('client-id'),
          limit: $target.data('count')
        });
      });
    }

    if ($parentSection.hasClass('twitter-feed-section')){
      $('.twitter-feed-wrap').each(function (index, value) {
        var twitterEnabled = $(this).data('twitter');
        social.twitter();
      });
    }

    if ($parentSection.hasClass('cart-section')){
      cart.init();
    }

    if ($parentSection.hasClass('image-with-text-overlay-section')){
      banner.init();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.init();
    }

    if ($parentSection.hasClass('featured-products-section')){
      product.init();
    }

    if ($parentSection.hasClass('featured-collection-section')){
      collection.init();
      product.init();
    }

    if ($parentSection.hasClass('testimonial-section')){
        testimonial.init();
    }

    if ($parentSection.hasClass('video-section')){
      video.init();
    }

    if ($parentSection.hasClass('product-template-section')){
      collection.init();
      product.init();
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonial.init();
    }

    if ($parentSection.hasClass('collection-template-section')){
      collection.init();
      product.init();
    }

    if ($parentSection.hasClass('article-template-section')){
      if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
      }
    }

    if ($parentSection.hasClass('search-template-section')){
      collection.init();
    }

    if ($parentSection.hasClass('header-section')){
      header.init();
    }
});


$(document)
  .on('shopify:section:unload', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);


    if ($parentSection.hasClass('image-with-text-overlay-section')){
      banner.unload($target);
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('featured-products-section')){
      product.unload($target);
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonial.unload($target);
    }

    if ($parentSection.hasClass('featured-collection-section')){
      collection.unload($target);
    }

    if ($parentSection.hasClass('product-template-section')){
      product.unload($target);
    }

    if ($parentSection.hasClass('collection-template-section')){
      collection.unload($target);
    }


});

$(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('twitter-feed-section')){
      $('.twitter-feed-wrap').each(function (index, value) {
        var twitterEnabled = $(this).data('twitter');
        social.twitter();
      });
    }
});

$(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

});